import { render, staticRenderFns } from "./SaleWeekly.vue?vue&type=template&id=64bc5658&scoped=true&"
import script from "./SaleWeekly.vue?vue&type=script&lang=js&"
export * from "./SaleWeekly.vue?vue&type=script&lang=js&"
import style0 from "./SaleWeekly.vue?vue&type=style&index=0&id=64bc5658&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bc5658",
  null
  
)

export default component.exports